export function plusminus(value) {
  if(value > 0) {
    return '+'+value;
  } else {
    return value.toString();
  }
}
